/*
 *   File : basic-filter.js
 *   Author : https://evoqins.com
 *   Description : basic filter component
 *   Integrations : NA
 *   Version : 1.0.0
 */
import React, { useState, useEffect } from "react";
import Select from "react-select";
import { createPortal } from "react-dom";
import "../../Style/Components/filter.scss";

/**
 * Full-page overlay rendered to document.body using a portal.
 * Mirrors the BodyOverlay pattern used in your Header example.
 */
const BodyOverlay = ({ onClose, zIndex = 1040 }) => {
  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "auto";
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, []);

  if (typeof document === "undefined") return null;

  return createPortal(
    <div
      className="position-fixed top-0 start-0 w-100 h-100"
      style={{ background: "rgba(0, 0, 0, 0.3)", zIndex }}
      onClick={onClose}
    />,
    document.body
  );
};

export default function BasicFilter({
  options = [],
  onChange,
  defaultActive,
  isSearchable = false,
}) {
  const [selectedOption, setSelectedOption] = useState(null);
  const [menuIsOpen, setMenuIsOpen] = useState(false);

  useEffect(() => {
    if (defaultActive) {
      const defaultOption = options.find((o) => o.value === defaultActive);
      setSelectedOption(defaultOption || null);
    }
  }, [defaultActive, options]);

  const handleChange = (option) => {
    setSelectedOption(option);
    if (onChange) onChange(option);
  };

  // react-select portal target (safe for SSR)
  const portalTarget =
    typeof document !== "undefined" ? document.body : null;

  return (
    <div className="e-basic-filter-wrapper e-cursor-pointer" style={{ position: "relative" }}>
      {/* Render overlay as a portal when select menu is open */}
      {menuIsOpen && (
        <BodyOverlay
          onClose={() => setMenuIsOpen(false)}
          zIndex={1040} // overlay z-index
        />
      )}

      <Select
        value={selectedOption}
        onChange={handleChange}
        options={options}
        isSearchable={isSearchable}
        classNamePrefix="custom-filter-select"
        // menuIsOpen={} // let react-select manage open state; we only observe via callbacks
        onMenuOpen={() => setMenuIsOpen(true)}
        onMenuClose={() => setMenuIsOpen(false)}
        menuPortalTarget={portalTarget}
        menuPosition="fixed"
        // ensure the menu appears above the overlay and other elements
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 1055 }),
        }}
      />
    </div>
  );
}
